import { reportError } from './report-error';
import {changeEmailFormat} from "./lead-email";

import {
    customForm,
    formatInterestOption,
    formatInterestSelection,
    formatOption,
    handlePopinAction,
    popLink,
    loadMultipleSelect,
    loadSellersList,
    handleChangePos,
    setCookie,
    showFlash,
    submitLinks,
    translate
} from './functions';

// Sans code, le bouton agenda ne ferait rien : l'utilisateur doit le savoir.
function reportCalendarDownloadFailure(reason) {
    console.error('Téléchargement du calendrier impossible : ' + reason);
    const flash = $('.js-flash-message-error').first();
    if (flash.length) {
        showFlash(flash, translate('app.error.generic'), true);
    } else {
        window.alert(translate('app.error.generic'));
    }
}

/**
 * Fermeture automatique des pages de confirmation ouvertes dans une fenêtre
 * dédiée : le délai, en millisecondes, est porté par le template.
 */
function autoCloseWindow() {
    const holder = document.querySelector('[data-auto-close-delay]');
    if (!holder) {
        return;
    }

    window.setTimeout(function () {
        window.close();
    }, Number(holder.dataset.autoCloseDelay));
}

export function closeWindow() {
    $('.--close-window').on('click', function() {
        self.close();
    })
}
const applyCti = function () {
    let cti_use = $('#cti_use').data('cti');
    if (cti_use === 'viadialog') {
        $('.confirm-call').on('click', function (event) {
            event.preventDefault();
            return confirm("Etes-vous sûr de vouloir appeler ce numéro ?");
        });
    } else if (cti_use === 'onc') {
        $('.confirm-call').click(function (event) {
            let num = $(this).data('num');

            window.external.Rcp2HtmlTabMakeCall(num, null);
            event.preventDefault();
        });
    }
};

export function hideProInfo() {

    const isPro = $('#lead_customer_pro, #contact_customer_pro, #customer_pro');
    if (isPro.length === 0) {
        return;
    }

    //Initial display
    if (isPro.is(":checked")) {
        $('.is-pro').removeClass('--hidden');
    }

    isPro.change(function(){
        let isChecked = $(this).is(":checked");
        if (isChecked === true) {
            $('.is-pro').removeClass('--hidden');
        } else {
            $('.is-pro').addClass('--hidden');
        }
    });
}
const showData = function (element) {
    element.addClass('--hidden');
    element.parents('.data').find('.content').removeClass('--hidden');
    element.parent().find('.hide-data').removeClass('--hidden');
};
const hideData = function (element) {
    element.addClass('--hidden');
    element.parents('.data').find('.content').addClass('--hidden');
    element.parent().find('.show-data').removeClass('--hidden');
};

/**
 * Lit la valeur d'un cookie par son nom.
 *
 * @param {string} name - Nom du cookie à lire.
 * @returns {string|null} Valeur du cookie, ou null s'il n'existe pas.
 */
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[2]) : null;
}

/**
 * Initialise les compteurs de notifications du menu (appels JDA, emails, contacts campagne).
 * Chaque compteur est mis à jour via une requête AJAX dédiée.
 * N'effectue les requêtes que si les éléments correspondants sont présents dans le DOM.
 *
 * @returns {void}
 */
function initMenuCounters() {
    // Construit un span compteur via l'API DOM (pas d'innerHTML) : évite toute
    // injection HTML si un champ du JSON venait à changer de type/source.
    // formattedValue : '' | number | '+999'.
    function buildCounterSpan({ id, formattedValue, warning = false, dataset = {} }) {
        const span = document.createElement('span');
        span.id = id;
        span.className = warning ? 'value --warning' : 'value';
        for (const [key, val] of Object.entries(dataset)) {
            span.dataset[key] = String(val);
        }
        span.textContent = formattedValue === '' ? '' : String(formattedValue);
        return span;
    }

    // Formate un nombre pour affichage badge : '' si 0/absent, '+999' au-delà, sinon la valeur.
    function formatBadgeValue(nb) {
        const n = Number(nb);
        if (!Number.isFinite(n) || n <= 0) return '';
        return n > 999 ? '+999' : n;
    }

    const jdaCounter = $('.nb-unanswered-call');
    if (jdaCounter.length > 0) {
        // JSON depuis le contrôleur — le span est construit ici. Structure alignée
        // avec les mutations faites par permission-counters.js sur les pushs WS :
        // même cible #nbUnansweredCalls, même classe --warning, même bornage +999.
        $.getJSON(Routing.generate('jda_get_nb_call_to_treat'), function (data) {
            const userId = jdaCounter.data('userid') ?? '';
            jdaCounter.empty().append(buildCounterSpan({
                id: 'nbUnansweredCalls',
                formattedValue: formatBadgeValue(data.nb),
                warning: Boolean(data.warning),
                dataset: { userid: userId },
            }));
        }).fail(function (jqXHR) {
            reportError('nb-unanswered-call XHR failed', jqXHR, { status: jqXHR.status });
        });
    }
    const emailCounter = $('.nb-emails-to-treat');
    if (emailCounter.length > 0) {
        // JSON depuis le contrôleur — le span est construit ici (userid porté par
        // le wrapper via Twig). Structure alignée avec les mutations faites par
        // permission-counters.js sur les pushs WS : même cible #nbEmailsToTreat,
        // même classe --warning, même bornage +999.
        $.getJSON(Routing.generate('get_nb_emails_to_treat'), function (data) {
            const userId = emailCounter.data('userid') ?? '';
            emailCounter.empty().append(buildCounterSpan({
                id: 'nbEmailsToTreat',
                formattedValue: formatBadgeValue(data.nb),
                warning: Boolean(data.warning),
                dataset: { userid: userId },
            }));
        }).fail(function (jqXHR) {
            reportError('nb-emails-to-treat XHR failed', jqXHR, { status: jqXHR.status });
        });
    }
    const contactCounter = $('.nb-contacts-to-treat');
    if (contactCounter.length > 0) {
        // JSON depuis le contrôleur — le span est construit ici. Structure alignée
        // avec permission-counters.js pour les pushs WS : même cible #nbContactsToTreat,
        // même classe --warning, même bornage +999.
        $.getJSON(Routing.generate('get_nb_contacts_to_treat'), function (data) {
            contactCounter.empty().append(buildCounterSpan({
                id: 'nbContactsToTreat',
                formattedValue: formatBadgeValue(data.nb),
                warning: Boolean(data.warning),
            }));
        }).fail(function (jqXHR) {
            reportError('nb-contacts-to-treat XHR failed', jqXHR, { status: jqXHR.status });
        });
    }
}

/**
 * Initialise le comportement du bouton de toggle du menu latéral.
 * Bascule entre les états étendu (--full) et réduit (--light),
 * et persiste l'état dans le cookie "mainMenuFull" (7 jours).
 * Utilise un namespace d'événement (.menu) pour permettre une réinitialisation propre.
 *
 * @returns {void}
 */
function initMenuToggle() {
    $('#toggleMainMenu').off('click.menu').on('click.menu', function () {
        const menu = $('#mainMenu');
        if (menu.hasClass('--full') || menu.hasClass('--light')) {
            if (menu.hasClass('--light')) {
                menu.removeClass('--light').addClass('--full');
                setCookie("mainMenuFull", '1', 7);
            } else {
                menu.removeClass('--full').addClass('--light');
                setCookie("mainMenuFull", '0', 7);
            }
        } else {
            if (window.innerWidth > 1024) {
                menu.addClass('--light');
                setCookie("mainMenuFull", '0', 7);
            } else {
                menu.addClass('--full');
                setCookie("mainMenuFull", '1', 7);
            }
        }
    });
}

/**
 * Callback exécuté après l'injection du HTML du menu dans le DOM.
 * Ré-applique l'état visuel depuis le cookie (nécessaire car le cache sessionStorage
 * peut contenir une classe obsolète), puis initialise le toggle et les compteurs.
 *
 * @returns {void}
 */
function onMenuInjected() {
    const state = getCookie('mainMenuFull');
    const menu = $('#mainMenu');
    menu.removeClass('--full --light');
    if (state === '1') menu.addClass('--full');
    else if (state === '0') menu.addClass('--light');
    initMenuToggle();
    initMenuCounters();
    popLink();
}

/**
 * Charge et injecte le menu latéral dans le DOM.
 *
 * Stratégie de cache :
 *  - Si le HTML est en sessionStorage (clé "mainMenu_<userId>") et âgé de moins de 30 min, injection synchrone.
 *  - Sinon, récupération via AJAX (/ajax/main-menu), mise en cache avec timestamp, puis injection.
 *
 * Sort silencieusement si le placeholder #mainMenu-placeholder est absent
 * (pages sans menu : formulaire lead, campagne, etc.).
 *
 * @returns {void}
 */
function loadMenu() {
    const placeholder = $('#mainMenu-placeholder');
    if (!placeholder.length) return;

    const userId = $('#value_user_id').val();
    const CACHE_TTL = 30 * 60 * 1000;

    const fetchAndInject = function (cacheKey) {
        $.get(Routing.generate('main_menu'), function (html) {
            if (cacheKey) {
                try {
                    sessionStorage.setItem(cacheKey, html);
                    sessionStorage.setItem(cacheKey + '_ts', Date.now().toString());
                } catch (e) {
                    // Cache best-effort : quota dépassé ou navigation privée,
                    // le menu est injecté sans être mis en cache.
                }
            }
            placeholder.replaceWith(html);
            onMenuInjected();
        }).fail(function () {
            placeholder.replaceWith('<nav id="mainMenu"></nav>');
        });
    };

    if (!userId || userId === '0') {
        fetchAndInject(null);
        return;
    }

    const cacheKey = 'mainMenu_' + userId;
    const cached = sessionStorage.getItem(cacheKey);
    const cachedAt = parseInt(sessionStorage.getItem(cacheKey + '_ts') || '0');

    if (cached && (Date.now() - cachedAt < CACHE_TTL)) {
        placeholder.replaceWith(cached);
        onMenuInjected();
        return;
    }

    fetchAndInject(cacheKey);
}

$(function () {

    loadMenu();
    submitLinks();

    if ($('#filterOrigin').length > 0) {

        $('#filterOrigin').keyup(function () {
            let keyword = $(this).val();
            $('#listOrigins .pad').each(function () {
                let name = $(this).find('.name').html().toLowerCase();
                if (name.indexOf(keyword.toLowerCase()) === -1) {
                    $(this).addClass('--hidden');
                } else {
                    $(this).removeClass('--hidden');
                }
            });
        });
    }

    //select2 + pré-remplissage si multiple
    let filtersSelects = ['#channel', '#interest', '#originFilter', '#selectOperator', '#select2seller', '#select2pos', '#select2posDisabled', '#evolution-range'];

    for (let i = 0; i < filtersSelects.length; i++) {

        let id = filtersSelects[i];
        let select = $('select' + id);
        let selectedValue = select.data('selected');

        if (typeof $.fn.select2 === 'function') {
            // Sur #select2seller, le libellé "Prénom Nom (Rôle)" est stylé via formatOption
            // (Prénom Nom en noir gras, Rôle en gris petit) — cf. .select2-part1/part3 dans telecom.scss.
            const isSeller = id === '#select2seller';
            // Puces colorées du filtre univers : la couleur vient de
            // .select2-selection__choice.interest-N (templates/common/_interests.css.twig).
            const isInterest = id === '#interest';
            select.select2({
                placeholder: $(this).data('placeholder'),
                allowClear: true,
                width: 160,
                ...(isSeller ? {
                    templateResult: formatOption,
                    templateSelection: formatOption,
                } : {}),
                ...(isInterest ? {
                    templateResult: data => formatInterestOption(data, data.id),
                    templateSelection: data => formatInterestSelection(data, data.id),
                } : {}),
            });
            if (select.prop('multiple') && selectedValue) {
                select
                    .val(selectedValue.toString().split(','))
                    .trigger('change');
            }
            $(".pos-select-email-libelle, .pos-select-phone-libelle").select2({
                allowClear: true,
            });
        }
    }



    if ($('#contentFilter').length > 0) {
        loadSellersList($('#contentFilter #select2pos'));
        loadMultipleSelect($('#select2seller'));
    }

    if (typeof $.fn.select2 === 'function' && $('#select2active').length > 0) {
        $('#select2active').select2({
            minimumResultsForSearch: -1,
            width: 'resolve'
        });
    }

    // Select « objet recherché » de la page de recherche, même rendu que le filtre de statut.
    if (typeof $.fn.select2 === 'function' && $('#search_type').length > 0) {
        $('#search_type').select2({
            minimumResultsForSearch: -1
        });
    }

    hideProInfo();

    $('.data .hide-data').click(function (event) {
        event.preventDefault();
        hideData($(this));
    });

    $('.data .show-data').click(function (event) {
        event.preventDefault();
        showData($(this));
    });

    $('#openUserMenu .button-icon').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass("active");
        $('#userMenu').toggleClass("active");
    });

    $(document).click(function (event) {
        if (!$(event.target).closest('#userMenu').length && !$(event.target).is('#openUserMenu')) {
            $('#openUserMenu').removeClass("active");
            $('#userMenu').removeClass("active");
        }
    });

    $('.close-flash').click(function (event) {
        event.preventDefault();
        $(this).parent('.flash-message').addClass('--hidden');
    });

    customForm();
    applyCti();
    closeWindow();
    autoCloseWindow();

    if ($('.flash-success:not(.js-flash-message-success)').length) {
        setTimeout(function() {
            $('.flash-success:not(.js-flash-message-success)').addClass('--hidden');
        }, 15000);
    }
    popLink();
    handlePopinAction();
    handleChangePos();

    // Le sanitizer des notes retire class et data-* du bouton « ajouter à mon agenda » : on le reconnaît à son lien
    // (Note::CALENDAR_BUTTON_HREF) et l'id du lead vient de la note. Tous masqués (CSS) sauf le premier.
    $('.lead-note-form.--with-appointment .note-content a[href="#add-to-calendar"]').first().addClass('--show-block');

    $(document).off('click.calendar').on('click.calendar', '.note-content a[href="#add-to-calendar"]', function(e) {
        e.preventDefault();
        let id = $(this).closest('.note-content').data('lead-id');
        if ($('#value_user_id').val() > 0) {
            window.location = Routing.generate('seller_appointment_download_calendar', { 'id' : id });
        } else {
            $.get(Routing.generate('get_url_code', {
                'id': id,
            }), function (data) {
                let code = data.code;
                if (code) {
                    window.location = Routing.generate('url_short', { 'url_code' : code, 'url_action': 'downloadCalendar' });
                } else {
                    reportCalendarDownloadFailure('code de téléchargement absent pour le lead ' + id);
                }
            }).fail(function (xhr) {
                reportCalendarDownloadFailure('HTTP ' + xhr.status + ' pour le lead ' + id);
            });
        }
    });

    changeEmailFormat();

    $('#editContactDetails').on('click', function(e) {
        e.preventDefault();
    })

    $(document).on('submit', '.seller-customer-edit form', function(e) {
        e.preventDefault();
        $('.seller-customer-edit > *').addClass('--hidden');
        $('.seller-customer-edit .common-loader').removeClass('--hidden');
        let form = $(this);
        let url = form.attr('action');
        let data = form.serialize();
        $.post(url, data, function(data) {
            if (data.success) {
                $('.custom-popin').remove();
                $('.opacity-layer').remove();
                $('.--contact-information > *').addClass('--hidden');
                $('.--contact-information .common-loader').removeClass('--hidden');
                $.get(Routing.generate('seller_customer_show', {'id': data.id}), function (data) {
                    $('.--contact-information').replaceWith(data);
                    handlePopinAction();
                });
            } else {
                $('.seller-customer-edit').replaceWith(data);
            }
        })

    })

    // Bascule visuelle des libellés de part et d'autre d'un switch : actif en noir, inactif en gris.
    // Idempotent : peut être ré-appelé après un rendu Ajax pour ré-initialiser l'état des nouveaux blocs.
    const refreshSwitchLabels = function ($input) {
        const $switchContainer = $input.closest('.switch-container');
        const $block = $switchContainer.closest('.switch-title-block');
        if (!$block.length) {
            return;
        }
        const checked = $input.is(':checked');
        $switchContainer.prevAll().toggleClass('--inactive', checked);
        $switchContainer.nextAll().toggleClass('--inactive', !checked);
    };
    window.initSwitchLabels = function () {
        $('.switch-title-block .switch-container input[type="checkbox"]').each(function () {
            refreshSwitchLabels($(this));
        });
    };
    $(document).on('change', '.switch-title-block .switch-container input[type="checkbox"]', function () {
        refreshSwitchLabels($(this));
    });
    window.initSwitchLabels();
});

export function resizeIframe() {
    const iframe = document.querySelector(".--full-height iframe");

    if (!iframe) return;

    try {
        const iframeDoc = iframe.contentWindow.document;

        const body = iframeDoc.body;
        const html = iframeDoc.documentElement;

        const height = Math.max(body.scrollHeight, html.scrollHeight);

        iframe.style.height = height + "px";
    } catch (e) {
        // Iframe cross-origin : la hauteur reste celle du CSS, rien à signaler.
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const iframe = document.querySelector(".--full-height iframe");

    if (iframe) {
        iframe.addEventListener("load", function () {
            resizeIframe();
        });
    }
});